import { useState } from "react";
import {
  Box,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Flex,
  Text,
} from "@chakra-ui/react";
import { BiPlay } from "react-icons/bi";
import { primaryColor, secondaryColorThree, white } from "../../../config";
import bajan_promo from '../../../resources/videos/bajan_medium_quality.mp4'


const colors = {
  bg: "#f6f0e7",
  paper: primaryColor,
  muted: "#b5ad9c",
  gold: "#c9a66b",
  line: secondaryColorThree,
  card: primaryColor,
};

function VideoPlayButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      {/* Play Button */}
      <Box
        css={{
          "@keyframes pulse": {
            "0%, 100%": {
              transform: "translate(-50%, -50%) scale(.92)",
              opacity: 0.3,
            },
            "50%": {
              transform: "translate(-50%, -50%) scale(1.04)",
              opacity: 1,
            },
          },
          "@keyframes mobilePulse": {
            "0%, 100%": {
              transform: "translate(-50%, -50%) scale(1)",
              opacity: 0.3,
            },
            "50%": {
              transform: "translate(-50%, -50%) scale(1.1)",
              opacity: 0.8,
            },
          },
        }}
        role="button"
        tabIndex={0}
        aria-label="Play video"
        cursor="pointer"
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        w={{ base: "90px", md: "310px" }}
        h={{ base: "90px", md: "310px" }}
        my={8}
        border="1px solid"
        borderColor="#f6f0e7"
        borderRadius="full"
        color={colors.paper}
        bg="rgba(255,255,255,.025)"
        transition="all .4s cubic-bezier(.2,.8,.2,1)"
        zIndex={1000}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => setIsOpen(true)}
        _before={{
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          width: { base: "80px", md: "350px" },
          height: { base: "80px", md: "350px" },
          border: { base: "1px solid rgba(254, 222, 167, 0.3)", md: "10px solid rgba(254, 222, 167, 0.2)" },
          borderRadius: "full",
          transform: "translate(-50%, -50%)",
          opacity: { base: 0.6, md: 0.3 },
          animation: { base: "mobilePulse 2s ease-in-out infinite", md: "pulse 2s ease-in-out infinite" },
        }}
        _after={{
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          width: { base: "70px", md: "370px" },
          height: { base: "70px", md: "370px" },
          border: { base: "2px solid rgba(255, 255, 255, 0.4)", md: "20px solid white" },
          borderRadius: "full",
          transform: "translate(-50%, -50%)",
          opacity: { base: 0.4, md: 0.3 },
          animation: { base: "mobilePulse 2s ease-in-out infinite reverse", md: "pulse 2s ease-in-out infinite" },
        }}
        _hover={{
          transform: "scale(1.28)",
          borderColor: colors.gold,
          bg: "#f6f0e7",
          boxShadow: "0 0 50px rgba(201,166,107,.2)",
        }}
      >
        <Flex flexDir={"column"} alignItems={"center"}>
          <Box display={{ base: "none", md: "block" }}>
            Know How Sound Affects you!
          </Box>
          <Icon
            as={BiPlay}
            boxSize={{ base: 42, md: 150 }}
            ml={1}
            transition="all .3s ease"
            transform={isHovered ? "scale(1.15)" : "scale(1)"}
            color={isHovered ? secondaryColorThree : primaryColor}
          />
          <Flex
            mt={{ base: 3, md: 5 }}
            direction="column"
            align="center"
            gap={1}
            color={primaryColor}
          // animation="listenHint 2.4s ease-in-out infinite"
          >
            <Text
              fontSize={{ base: "10px", md: "14px" }}
              letterSpacing="0.2em"
              textTransform="uppercase"
              display={{ base: "none", md: "block" }}
            >
              Click to Know!
            </Text>

            <Text
              display={{ base: "block", md: "none" }}
              fontSize={{ base: "10px", md: "14px" }}
              letterSpacing="0.2em"
              textTransform="uppercase"
            >
              Click!
            </Text>

          </Flex>

        </Flex>

      </Box>

      {/* Video Modal */}
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onEsc={() => setIsOpen(false)}
        size="6xl"
        isCentered
      >
        <ModalOverlay bg="rgba(0,0,0,.85)" />

        <ModalContent
          bg="black"
          maxW="1000px"
          mx={4}
          overflow="hidden"
        >
          <ModalCloseButton
            zIndex={10}
            color="white"
            bg="rgba(0,0,0,.5)"
            borderRadius="full"
          />

          {/* <ModalBody
            p={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            overflow="hidden"
            maxH="calc(100vh - 120px)"
          >
            <Box
              position="relative"
              h="calc(100vh - 120px)"
              aspectRatio="9 / 16"
              maxW="100%"
            >
              <Box
                as="iframe"
                position="absolute"
                inset={0}
                w="100%"
                h="100%"
                src={bajan_promo}
                title="Sound Is an Experience"
                border="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            </Box>
          </ModalBody> */}
          <ModalBody p={0} overflow="hidden">
            <Box
              w="100%"
              h="calc(100vh - 120px)"
              display="flex"
              justifyContent="center"
              alignItems="center"
              bg="black"
              overflow="hidden"
            >
              <Box
                as="video"
                src={bajan_promo}
                // onLoadedMetadata={(e) => {
                //   (e.target as HTMLVideoElement).playbackRate = 2.0;
                // }}
                autoPlay={true}
                title="Sound Is an Experience"
                w="100%"
                h="100%"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                onContextMenu={(e: React.MouseEvent) => e.preventDefault()}
              />
            </Box>
          </ModalBody>

        </ModalContent>
      </Modal>
    </>
  );
}

export default VideoPlayButton;